const { isEmpty } = require('lodash');

const { prefectures, } = require('../config');

const { entries } = Object;

module.exports = {
  fields: () => {
    return {
      postalCode: {
        type: 'string',
        label: '郵便番号',
        validations: {
          required: v => !isEmpty(v),
          format: v => (v || '').match(/^[0-9]{7}$/g),
        },
        inputProps: {
          type: 'tel',
        },
      },
      prefecture: {
        label: '都道府県',
        type: 'select',
        options: entries(prefectures).map(([k, v]) => ({ value: k, label: v })),
        validations: {
          required:  v => !isEmpty(v),
        },
      },
      city: {
        type: 'string',
        label: '市区郡町村',
        validations: {
          required: v => !isEmpty(v),
        },
      },
      address1: {
        type: 'string',
        label: '町・番地',
        validations: {
          required: v => !isEmpty(v),
        },
      },
      address2: {
        type: 'string',
        label: 'マンション・ビル名',
      },
      name: {
        label: '氏名',
        type: 'string',
        validations: {
          required: v => !isEmpty(v),
        },
      },
      phone: {
        type: 'string',
        inputType: 'tel',
        label: '電話番号',
        validations: {
          required: v => !isEmpty(v),
          format: v => !v || v.match(/^(0{1}\d{9,10})$/),
        },
        placeholder: '08012345678 （ハイフンなし）',
        format: _ => _.replace(/-/g, ''),
      },
    };
  },
};
